import { PolicyApply } from '../interfaces/policy-apply.interface';

/** Stub: MileagePolicy apply. */
export const MileagePolicy: PolicyApply<
	unknown,
	unknown,
	Record<string, unknown>
> = {
	apply(
		_input: unknown,
		_config: Record<string, unknown> | null | undefined,
	): unknown {
		return null;
	},
};
